module.exports = __webpack_public_path__ + "img/javaMobile5.2a296c14.jpg";